<div class="modal-container">
	<div class="actions">
		<mat-icon
			(click)="closeClicked()"
			matRipple
			style="cursor: pointer; border-radius: 100%"
			>close
		</mat-icon>
	</div>

	<form (ngSubmit)="submit()" [formGroup]="myForm" class="chart-point-edit-form">
		<div style="display: flex; flex-direction: column">
			<mat-form-field appearance="fill">
				<mat-label>{{ 'edit_component_name' | translate }}</mat-label>
				<input formControlName="name" matInput />
				@if (myForm.controls['name'].invalid) {
					<mat-error>
						{{ 'required' | translate }}
					</mat-error>
				}
			</mat-form-field>
		</div>

		<div class="form-actions">
			<div class="submit-cancel-buttons">
				<au-techno-btn (click)="closeClicked()" mat-dialog-close>
					{{ 'cancel' | translate }}
				</au-techno-btn>

				<button
					[disabled]="!myForm.valid"
					class="au-btn save-button"
					matRipple
					type="submit"
				>
					{{ 'submit' | translate }}
				</button>
			</div>
		</div>
	</form>
</div>
